import { duplicate } from "./editOrderStateSet";
import { OrderActions } from "./orderActions";
import { orderCaculation } from "./OrderCalculation";
import { orderState } from "./orderState";

function orderReducer(state, action) {
  switch (action.type) {
    case OrderActions.ADDON_ADD:
      let recipents = [...state.recipents];
      recipents[state.activeRecipentIndex].addedAddons = [
        ...recipents[state.activeRecipentIndex].addedAddons,
        ...action.payload,
      ];
      // recipents[state.activeRecipentIndex].addedAddons.push(action.payload);
      return {
        ...state,
        recipents: recipents,
      };
    case OrderActions.REMOVE_PRODUCT_ITEM:
      let recipentsProduct = [...state.recipents];
      recipentsProduct[state.activeRecipentIndex].added_product.splice(
        action.payload,
        1
      );
      return {
        ...state,
        recipents: recipentsProduct,
      };
    case OrderActions.PRODUCT_ADD:
      let rcp = [...state.recipents];
      rcp[state.activeRecipentIndex].added_product = [
        ...rcp[state.activeRecipentIndex].added_product,
        ...action.payload,
      ];
      // rcp[state.activeRecipentIndex].added_product.push(action.payload);
      return {
        ...state,
        recipents: rcp,
      };
    case OrderActions.INCRESS_PRODUCT_QTY:
      let recipentsProductQty = [...state.recipents];
      recipentsProductQty[state.activeRecipentIndex].added_product[
        action.payload
      ].qty++;
      recipentsProductQty[state.activeRecipentIndex].added_product[
        action.payload
      ].total_price =
        recipentsProductQty[state.activeRecipentIndex].added_product[
          action.payload
        ].qty *
        recipentsProductQty[state.activeRecipentIndex].added_product[
          action.payload
        ].selectedVariant.price;
      return { ...state, recipents: recipentsProductQty };
    case OrderActions.DECRESS_PRODUCT_QTY:
      let recipentsProductQtyd = [...state.recipents];
      recipentsProductQtyd[state.activeRecipentIndex].added_product[
        action.payload
      ].qty--;
      recipentsProductQtyd[state.activeRecipentIndex].added_product[
        action.payload
      ].total_price =
        recipentsProductQtyd[state.activeRecipentIndex].added_product[
          action.payload
        ].qty *
        recipentsProductQtyd[state.activeRecipentIndex].added_product[
          action.payload
        ].selectedVariant.price;
      return { ...state, recipents: recipentsProductQtyd };
    case OrderActions.CALCULATE:
      let newState = orderCaculation(state);
      return newState;
    case OrderActions.DELETE_PRODUCT_ID:
      let deleteArray = [...state.recipents];
      if (deleteArray[state.activeRecipentIndex]?.form?.id) {
        deleteArray[state.activeRecipentIndex].deleted_recipient_product_id =
          deleteArray[state.activeRecipentIndex].deleted_recipient_product_id ||
          [];
        deleteArray[
          state.activeRecipentIndex
        ]?.deleted_recipient_product_id.push(action.payload?.toString());
        return {
          ...state,
          recipents: deleteArray,
        };
      } else {
        return state;
      }
    case OrderActions.SET_DISSCOUNT_DETAILS:
      let orderDisscount = {
        ...state.order,
        discount_percentage: action.payload.discount_percentage,
        discount_price: action.payload.discount_price,
        custom_reason_for_discount: action.payload.custom_reason_for_discount,
      };
      let orderTransaction = {
        ...state.order_transaction,
        discount_price: action.payload.discount_price,
      };
      return {
        ...state,
        order: orderDisscount,
        order_transaction: orderTransaction,
      };
    case OrderActions.CLEAR_DELIVERY_DATA:
      return {
        ...state,
        leadTime: action.payload,
      };
    case OrderActions.DUPLICATE_ORDER:
      let nos = duplicate(action.payload, state, "Duplicate");
      return nos;

    case OrderActions.RESET:
      let o = {
        ...orderState,
        recipents: [
          {
            form: {
              recipients_id: 0,
              whats_the_occasion: "",
              whats_the_occasion_id: null,
              first_name: "",
              last_name: "",
              greetings_on_card: "",
              card_signature: "",
            },
            added_product: [],
            addedAddons: [],
          },
        ],
        billing_data: {
          customer_billing_first_name: "",
          customer_billing_last_name: "",
          customer_billing_address: "",
          customer_billing_city: "",
          customer_billing_state: "",
          customer_billing_country: "United States",
          customer_billing_zipcode: "",
          customer_id: 0,
          completed: false,
        },
      };

      return o;

    case OrderActions.REPLACE_ORDER:
      let repl = duplicate(action.payload, state, "Replace");
      return {
        ...repl,
        order_type_identifier: 1,
      };

    default:
      return state;
  }
}

export default orderReducer;
